<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title30"></a><div class="title-toc">Contents</div>
<p class="toc1"><a href="#/e9780806537054_c01"><strong class="b">I</strong> - <strong class="b">MAN’S RECORD OF BELIEFS</strong></a></p>
<p class="toc1"><span href="#/e9780806537054_c02" title="Link target outside of Sample"><strong class="b">II</strong> - <strong class="b">INTELLECTUAL RUBBISH</strong></span></p>
<p class="toc1"><span href="#/e9780806537054_c03" title="Link target outside of Sample"><strong class="b">III</strong> - <strong class="b">ATHEISM AND AGNOSTICISM</strong></span></p>
<p class="toc1"><span href="#/e9780806537054_c04" title="Link target outside of Sample"><strong class="b">IV</strong> - <strong class="b">ON BEING OLD</strong></span></p>
<p class="toc1"><span href="#/e9780806537054_ftn01" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780806537054_toc01.vue?698673b7